/**
 * The clinic's chosen shape, applied to the running page.
 *
 * Lives beside the branding helper rather than in the settings screen: the
 * shell applies it on every load and the settings screen applies it when it
 * changes, so it belongs to neither of them.
 *
 * `index.html` stamps the root from storage before first paint — applied any
 * later it is a visible jump on every page load. This keeps the two in step.
 *
 * The mirror is per clinic without doing anything: every clinic is its own
 * domain, `localStorage` is keyed by origin, and the two development clinics
 * are `localhost` and `orthodontica.localhost`. Somebody signed into both at
 * once gets each one's own shape on its own tab, which is the behaviour that
 * would have needed inventing if origins did not already give it.
 */
const STORAGE_KEY = 'df.appearance';

export function applyAppearance(value: string) {
  const root = document.documentElement;
  if (value) root.dataset.appearance = value;
  else delete root.dataset.appearance;
  try {
    if (value) localStorage.setItem(STORAGE_KEY, value);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Private mode: it applies now and reverts on the next load, which is
    // better than refusing to apply it at all.
  }
}
